import { createApiClient } from '@chipn/api-client';
import { configureQueries } from '@chipn/queries';
import { env } from './env';
import { getAccessToken } from './supabase';

export { ApiRequestError, unwrap } from '@chipn/api-client';
export const api = createApiClient({ baseUrl: env.apiUrl, getAccessToken });
configureQueries(api);
